import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { ReactComponent as CloseIcon } from "../assets/x.svg";
import { ReactComponent as MenuIcon } from "../assets/menu.svg";
import "../css/newnavbar.css";

const NewNavbar = () => 
{
   const [click, setClick] = useState(false);
   const handleClick = () => setClick(!click);
   const closeMobileMenu = () => setClick(false);

   return (
      <div className="navbar">
         <Link to="">Max Morse</Link>
         <div className={click ? "nav-links active" : "nav-links"}>
               <Link to="/projects" className="option" onClick={closeMobileMenu}>Projects</Link>
               <Link to="/resume" className="option" onClick={closeMobileMenu}>Resume</Link>
         </div>
         <div className="mobile-menu-button" onClick={handleClick}>
            {click ? <CloseIcon className="menu-icon" /> : <MenuIcon className="menu-icon" />}
         </div>
      </div>
   );
}

export default NewNavbar;
